<template>
	<vs-prompt
		:active.sync="activePrompt"
		:buttons-hidden="true"
		:title="$t('downloadAuthorsFiles')"
		button-cancel="filled"
		class="files-upload-popup"
		fullscreen
		@keydown.esc="closePopup"
		@close="close"
	>
		<UploadAuthorsWork
			:order-status="orderStatus"
			:order-id="orderId"
			:stage="stage"
			@update-model="updateModel"
		/>
	</vs-prompt>
</template>

<script>
import UploadAuthorsWork from '@/components/authors/UploadAuthorsWork.vue'

export default {
	name: 'UploadJuniorAuthorWorkDialog',

	props: {
		active: {
			required: true,
			type: Boolean
		},
		orderId: { required: true, type: Number, default: -1 },
		orderStatus: { required: true, type: String, default: '' },
		stage: { type: Object, default: () => ({}) },
	},

	components: {
		UploadAuthorsWork,
	},

	created() {
		document.addEventListener('keyup', this.closePopup);
	},

	destroyed() {
		document.removeEventListener('keyup', this.closePopup);
	},

	computed: {
		activePrompt: {
			get() {
				return this.active;
			},
			set(value) {
				this.$emit("update:active", value);
			}
		},
	},

	methods: {
		async updateModel() {
			await this.$emit("updateModel");
			this.activePrompt = false
		},

		closePopup(e) {
			if (e.keyCode === 27) {
				this.activePrompt = false
			}
		},

		close() {
			this.activeProp = false;
		}
	}
}
</script>

<style lang="scss">
.files-upload-popup {
	.vs-dialog {
		max-width: max-content;
	}
}
</style>
